import type { PostType } from './types';

export const POST_TYPE_LABELS: Record<PostType, string> = {
  0: 'Blog',
  1: 'Review',
  2: 'Ownership Tip',
  3: 'Discussion',
  4: 'Staff post'
};

/** Mantine badge color names for PostTypeBadge. */
export const POST_TYPE_BADGE_COLORS: Record<PostType, string> = {
  0: 'blue',
  1: 'cyan',
  2: 'orange',
  3: 'gray',
  4: 'grape'
};

/** CSS token colors for PillBadge / search rows. */
export const POST_TYPE_TOKEN_COLORS: Record<PostType, string> = {
  0: 'var(--gs-blue)',
  1: 'var(--gs-info)',
  2: 'var(--gs-accent)',
  3: 'var(--gs-muted)',
  4: 'var(--gs-purple, #8957e5)'
};

export const BASE_POST_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: '0', label: 'Blog' },
  { value: '1', label: 'Review' },
  { value: '2', label: 'Ownership tip' },
  { value: '3', label: 'Discussion' }
];

export const STAFF_POST_TYPE_OPTION = { value: '4', label: 'Staff post' };

export const BLOG_POST_TYPE_FILTER_OPTIONS: { value: number | undefined; label: string }[] = [
  { value: undefined, label: 'All' },
  { value: 0, label: POST_TYPE_LABELS[0] },
  { value: 1, label: POST_TYPE_LABELS[1] },
  { value: 2, label: POST_TYPE_LABELS[2] },
  { value: 3, label: POST_TYPE_LABELS[3] },
  { value: 4, label: POST_TYPE_LABELS[4] }
];

export function postTypeLabel (type: number): string {
  return POST_TYPE_LABELS[type as PostType] ?? 'Post';
}

export function postTypeBadgeColor (type: number): string {
  return POST_TYPE_BADGE_COLORS[type as PostType] ?? 'gray';
}
